'use client';
import styled from 'styled-components';

export const DotsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

export const Dot = styled.button`
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  /* Outer hit area keeps touch targets comfortable */
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  width: ${props => (props.$active ? '24px' : '6px')};

  &::after {
    content: '';
    display: block;
    height: 6px;
    width: ${props => (props.$active ? '24px' : '6px')};
    border-radius: 3px;
    background-color: white;
    opacity: ${props => (props.$active ? 1 : 0.4)};
    transition: width 300ms ease, opacity 300ms ease;
  }

  &:focus-visible {
    outline: 2px solid white;
    outline-offset: 2px;
    border-radius: 3px;
  }
`;
